export default "__VITE_ASSET__9cc9b287__"